<template>
	<div class="avatar-container" v-bind:style="avatarStyle">
		<popup-maid v-bind:visible="showPopup" v-on:close-popup="actionAvatar"
			v-on:action-popup="editMaid" v-bind:time="time" v-bind:type-cleaning="typeCleaning"
			v-bind:name="`${firstname} ${lastname}`" />
		<span class="avatar-text" v-on:click="actionAvatar">{{avatarLetters}}</span>
	</div>
</template>

<script>

	import PopupMaid from './PopupMaid';

	function actionAvatar(value) {
		if (value === 1) {
			this.showPopup = false;
		} else {
			this.showPopup = !this.showPopup;
		}
	}

	function avatarLetters() {
		const firstLetterName = this.firstname.substring(0, 1);
		const firstLetterLastName = this.lastname.substring(0, 1);
		return `${firstLetterName}${firstLetterLastName}`;
	}

	function avatarStyle() {
		return `background-color:${this.color};height:${this.height};width:${this.width}`;
	}

	function data() {
		return {
			showPopup: false,
		};
	}

	function editMaid() {
		this.$router.push({ name: 'users-config', params: { userId: this.$attrs.id } });
	}

	export default {
		name: 'avatar-profile',
		components: {
			PopupMaid,
		},
		computed: {
			avatarLetters,
			avatarStyle,
		},
		data,
		props: {
			color: {
				type: String,
				default: '#00ca52',
			},
			firstname: {
				type: String,
				required: true,
			},
			height: {
				type: String,
				default: '26px',
			},
			lastname: {
				type: String,
				required: true,
			},
			time: {
				type: String,
				default: '',
			},
			typeCleaning: {
				type: String,
				default: '',
			},
			width: {
				type: String,
				default: '26px',
			},
		},
		methods: {
			actionAvatar,
			editMaid,
		},
	};
</script>

<style scoped>
.avatar-container {
	align-items: center;
	border-radius: 50%;
	display: flex;
	justify-content: center;
	position: relative;
}
.avatar-text {
	color: #fff;
	cursor: pointer;
	text-transform: uppercase;
}
</style>


// WEBPACK FOOTER //
// AvatarProfile.vue?ea933218